import { useTranslation } from 'react-i18next'
import questionButtonImage from '../../../assets/images/buttons/question_button.png'
import { useAnal, useModal } from '../../../hooks'
import { EModalName } from '../../../types/enums'
import { Icon } from '../../atoms'

export const SupportButton = (props: { className?: string }) => {
  const { openConfirmationModal } = useModal()
  const { t } = useTranslation()
  const { logEvent } = useAnal()

  const onClick = async () => {
    const { closeModal } = openConfirmationModal(
      {
        text: t('modal.confirmation.support.text'),
        mainButtonText: t('modal.confirmation.support.confirm'),
        secondaryButtonText: t('modal.confirmation.support.cancel'),
      },
      {
        title: t('modal.confirmation.support.title'),
        closeOnClickOutside: true,
        name: EModalName.CONFIRM_SUPPORT,
      },
    )

    const result = await closeModal
    if (result !== 'main') {
      return
    }
    logEvent('confirm_support_request')
    window.open(import.meta.env.VITE_SUPPORT_BOT_URL as string)
  }

  return (
    <Icon
      src={questionButtonImage}
      className={props.className}
      alt='Support'
      analytic={{
        name: 'support_icon',
      }}
      onClick={() => {
        void onClick()
      }}
    />
  )
}
